export default __webpack_public_path__ + "static/media/bagwadd.7b3a6ad8.jpg";